const CERTIFICATE_ENGINEER_BY_USER_EMAIL: Record<string, string> = {
  'yl@linfinityeng.com': 'Yuan Lin',
  'wd@linfinityeng.com': 'Wilson Du',
  'wd@eqeng.com.au': 'Wilson Du',
  'wdu@eqeng.com.au': 'Wilson Du',
};

export function resolveCertificateEngineerNameForUser(userEmail?: string | null) {
  const normalizedEmail = String(userEmail || '').trim().toLowerCase();
  return CERTIFICATE_ENGINEER_BY_USER_EMAIL[normalizedEmail] || '';
}
